import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ButtonProps } from '../../../Button';
import { Text } from '../../../Text';
import { EmptyLessonCardEntry } from '../EmptyLessonCardEntry/EmptyLessonCardEntry';
import './CurrentLessonCard.scss';

export interface CurrentLessonCardProps {
  title: string;
  actionButton?: JSX.Element;
  refreshButton?: ButtonProps;
  headActionButton?: JSX.Element;
  children?: React.ReactNode;
}

/**
 * Card layout element for wrapping contents of the current lesson
 */
export const CurrentLessonCard: React.FC<CurrentLessonCardProps> = props => {
  const { t } = useTranslation();
  return (
    <div className="currentLessonCard" tabIndex={0}>
      <div className="cardHead">
        <Text as="h4" weight="bold">{props.title}</Text>
        <div className="headerButtonWrapper">
          {props.headActionButton}
          {props.refreshButton && (
            <Button
              {...props.refreshButton}
              appearance="transparent"
              className="refreshBtn"
              size="small"
              aria-label={t('classbook:refresh_label', { defaultValue: 'Aktualisierung des Bereichs' })}
            />
          )}
        </div>
      </div>
      <div className="cardContent">
        {React.Children.toArray(props.children).length === 0 && (
          <div className="spacer">
            <EmptyLessonCardEntry />
          </div>
        )}
        {props.children}
        {props.actionButton && (
          <div className="btnWrapper">{props.actionButton}</div>
        )}
      </div>
    </div>
  );
};
